/* tslint:disable */
/* eslint-disable */
/**
 * Shopping Cart API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CartLoanInfosDto } from './CartLoanInfosDto';
import {
    CartLoanInfosDtoFromJSON,
    CartLoanInfosDtoFromJSONTyped,
    CartLoanInfosDtoToJSON,
    CartLoanInfosDtoToJSONTyped,
} from './CartLoanInfosDto';
import type { CartBorrowerInfosDtoPricing } from './CartBorrowerInfosDtoPricing';
import {
    CartBorrowerInfosDtoPricingFromJSON,
    CartBorrowerInfosDtoPricingFromJSONTyped,
    CartBorrowerInfosDtoPricingToJSON,
    CartBorrowerInfosDtoPricingToJSONTyped,
} from './CartBorrowerInfosDtoPricing';

/**
 * 
 * @export
 * @interface CartBorrowerInfosDto
 */
export interface CartBorrowerInfosDto {
    /**
     * 
     * @type {string}
     * @memberof CartBorrowerInfosDto
     */
    id: string;
    /**
     * 
     * @type {CartBorrowerInfosDtoPricing}
     * @memberof CartBorrowerInfosDto
     */
    pricing?: CartBorrowerInfosDtoPricing;
    /**
     * 
     * @type {Array<CartLoanInfosDto>}
     * @memberof CartBorrowerInfosDto
     */
    loans: Array<CartLoanInfosDto>;
}

/**
 * Check if a given object implements the CartBorrowerInfosDto interface.
 */
export function instanceOfCartBorrowerInfosDto(value: object): value is CartBorrowerInfosDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('loans' in value) || value['loans'] === undefined) return false;
    return true;
}

export function CartBorrowerInfosDtoFromJSON(json: any): CartBorrowerInfosDto {
    return CartBorrowerInfosDtoFromJSONTyped(json, false);
}

export function CartBorrowerInfosDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CartBorrowerInfosDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'pricing': json['pricing'] == null ? undefined : CartBorrowerInfosDtoPricingFromJSON(json['pricing']),
        'loans': ((json['loans'] as Array<any>).map(CartLoanInfosDtoFromJSON)),
    };
}

export function CartBorrowerInfosDtoToJSON(json: any): CartBorrowerInfosDto {
    return CartBorrowerInfosDtoToJSONTyped(json, false);
}

export function CartBorrowerInfosDtoToJSONTyped(value?: CartBorrowerInfosDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'pricing': CartBorrowerInfosDtoPricingToJSON(value['pricing']),
        'loans': ((value['loans'] as Array<any>).map(CartLoanInfosDtoToJSON)),
    };
}

